module.exports = __webpack_public_path__ + "img/screenshot.b2d209ab.jpg";